export const AINA_VOICE_AGENT = "AINA_VOICE";
export const AINA_MENTOR_AGENT = "AINA_MENTOR";

export type AinaAndroidFeatureFlags = {
  /** RC / learn: `aina_disable_mic` — voice and mentor */
  ainaDisableMic?: boolean;
  /** RC / learn: `aina_disable_doubts` — voice only; mentor doubts are always disabled. */
  ainaDisableDoubts?: boolean;
};

export type AinaMicDoubtsRemoteKeyMode = "voice" | "mentor";

export function classifyAinaAgentForMicDoubtsRemoteKeys(
  agent: string | undefined,
): AinaMicDoubtsRemoteKeyMode {
  const a = (agent ?? "").trim().toUpperCase();
  if (!a) {
    return "mentor";
  }
  if (a === AINA_MENTOR_AGENT || a.includes("MENTOR")) {
    return "mentor";
  }
  if (a === AINA_VOICE_AGENT || a.includes("VOICE")) {
    return "voice";
  }
  return "mentor";
}

export function isAinaVoiceAgent(agent: string | undefined): boolean {
  return classifyAinaAgentForMicDoubtsRemoteKeys(agent) === "voice";
}

export function resolveAinaDisableMicForLaunch(
  _agent: string | undefined,
  flags?: AinaAndroidFeatureFlags | null,
): boolean {
  const f = flags ?? undefined;
  return f?.ainaDisableMic ?? false;
}

export function resolveAinaDisableDoubtsForLaunch(
  agent: string | undefined,
  flags?: AinaAndroidFeatureFlags | null,
): boolean {
  if (classifyAinaAgentForMicDoubtsRemoteKeys(agent) === "mentor") {
    return true;
  }
  const f = flags ?? undefined;
  return f?.ainaDisableDoubts ?? false;
}
